import { useMemo, useRef } from 'react';
import { usePathname } from 'expo-router';
import { parseISO, isValid } from 'date-fns';

export const useCurrentOverviewDate = () => {
  const pathname = usePathname();
  const todayRef = useRef(new Date());

  // Parse date from URL pathname or fallback to today
  const selectedDate = useMemo(() => {
    // Extract date from pathname like "/2025-11-28" or "/(tabs)/2025-11-28"
    const dateMatch = pathname.match(/\/(\d{4}-\d{2}-\d{2})/);
    if (dateMatch) {
      const overviewDate = dateMatch[1];
      const parsedDate = parseISO(overviewDate);
      return isValid(parsedDate) ? parsedDate : todayRef.current;
    }
    return todayRef.current;
  }, [pathname]);

  return selectedDate;
};
